function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
function VideoCameraOffCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "currentColor"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "29",
    height: "29",
    rx: "14.5",
    stroke: "none",
    fill: props.fill
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.7998 11.3996C7.7998 10.9222 7.98945 10.4644 8.32701 10.1268C8.66458 9.78925 9.12241 9.59961 9.5998 9.59961H14.9998C15.4772 9.59961 15.935 9.78925 16.2726 10.1268C16.6102 10.4644 16.7998 10.9222 16.7998 11.3996V18.5996C16.7998 19.077 16.6102 19.5348 16.2726 19.8724C15.935 20.21 15.4772 20.3996 14.9998 20.3996H9.5998C9.12241 20.3996 8.66458 20.21 8.32701 19.8724C7.98945 19.5348 7.7998 19.077 7.7998 18.5996V11.3996ZM19.0975 12.395C18.948 12.4697 18.8223 12.5845 18.7344 12.7266C18.6465 12.8687 18.5999 13.0325 18.5998 13.1996V16.7996C18.5999 16.9667 18.6465 17.1305 18.7344 17.2726C18.8223 17.4147 18.948 17.5295 19.0975 17.6042L20.8975 18.5042C21.0347 18.5728 21.1871 18.6051 21.3403 18.5982C21.4935 18.5913 21.6424 18.5454 21.7728 18.4648C21.9033 18.3842 22.011 18.2716 22.0857 18.1377C22.1605 18.0038 22.1997 17.853 22.1998 17.6996V12.2996C22.1997 12.1463 22.1605 11.9955 22.0857 11.8616C22.011 11.7276 21.9033 11.615 21.7728 11.5344C21.6424 11.4538 21.4935 11.4079 21.3403 11.401C21.1871 11.3941 21.0347 11.4265 20.8975 11.495L19.0975 12.395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "19",
    y1: "10.5355",
    x2: "8.53553",
    y2: "21",
    stroke: props.fill,
    strokeWidth: "5",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "21",
    y1: "8.41421",
    x2: "8.41421",
    y2: "21",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round"
  }));
}
export default VideoCameraOffCircle;
//# sourceMappingURL=VideoCameraOffCircle.js.map